import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => ({
  root: {
    borderRadius: theme.tokens.radius.card,
    overflow: "hidden",
    backgroundColor: theme.tokens.color.surface
  },
  image: {
    display: "block",
    width: "100%",
    height: "auto",
    aspectRatio: "1000 / 333"
  }
}));

export default withCustomStyles;
